export const Endpoints = {
  plans: "subscription-plans",
  subscriptions: "subscriptions",
  users: "users",
  cards: "credit-card",
  login: "login",
  appointments: "appointments",
  callEvents: "call-event",
  termsOfUse: "terms-of-use-psi",
  occupationAreas: "occupation-area",
  banks: "bank-codes",
  updateStripePending: "users/stripe-connect",
  homeInfo: "home-info",
  chats: "appointment-chats",
  chatMessages: "appointment-chat-messages",
  payouts: "payouts",
  notifications: "notifications",
  notificationSettings: "",
  coupons: "coupons",
  privacyPolicy: "privacy-policy",
  myBanks: "my-banks",
  callRating: "calls-rating",
  reviewCallRating: "rating-review-requested",
  languages: "languages",
  approaches: "approaches",
  availableDays: "find-psychologists/availableDays",
  specificDaySchedules: "specific-day-schedules",
  recurrenciesVerification: "appointment-recurrencies/verification",
  rescheduleRequests: "reschedule-requests",
  availableTimes: "find-psychologists/availableTimes",
  patients: "patients",
  recurrencies: "appointment-recurrencies",
  stripeConnectOnboarding: "users/stripe-connect-onboarding",
  forgotPassword: "password/email",
  resetPassword: "password/reset",
  stripeConnectReset: "users/stripe-connect-reset",
  verifyRegisterAvailability: "psy-signup-active",
};
